import HTML5 from './HTML5.png';
import CSS3 from './CSS3.png';
import JAVASCRIPT from './JAVASCRIPT.png';
import NODEJS from './NODEJS.png';
import REACT from './REACT.png'
import MONGODB from './MONGODB.png'
import MYSQL from './MYSQL.png';
import BOOTSTRAP from './BOOTSTRAP.png'
import TAILWIND from './TAILWIND.png'


// Here I am importing all the images of the projects being displayed through the Project component in the Portfolio page


export default  {HTML5, CSS3, JAVASCRIPT, NODEJS, REACT, MONGODB, MYSQL, BOOTSTRAP, TAILWIND}

